import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ActiveTasksContext from '../../providers/ActiveTasksContext';
import language from '../../variables/language';
import IconDone from '../icons/IconDone';
import IconWrong from '../icons/IconWrong';
import IconCloseX from '../icons/IconCloseX';

// Persistent "what's the system doing right now" widget, rendered once at
// app root (see App.js) so it's visible no matter which page the teacher is
// on - the whole point of collapsing QuizGenerationModal into a task is
// that navigating away must NOT lose sight of it. Deliberately generic
// (switches on task.type) even though only 'quiz-generation' exists today.
export default function ActiveTasksTray() {
   const { tasks, dismissTask } = useContext(ActiveTasksContext);
   const navigate = useNavigate();
   const lang = language[language.lang];
   const t = lang.activeTasks;

   if (tasks.length === 0) {
      return '';
   }

   const labelFor = (task) => {
      if (task.type !== 'quiz-generation') return '';
      if (task.status === 'running') return t.quizGenerationRunning + ' ' + task.studentLabel;
      if (task.status === 'success') return t.quizGenerationSuccess + ' ' + task.studentLabel;
      return t.quizGenerationError + ' ' + task.studentLabel;
   };

   const handleClick = (task) => {
      if (task.type === 'quiz-generation' && task.status === 'success' && task.conversationId) {
         navigate('/conversations-creator-canvas/' + task.conversationId);
      }
   };

   return (
      <div className='active-tasks-tray' title={t.trayTitle}>
         {tasks.map((task) => (
            <div key={task.id}
               className={'active-tasks-chip active-tasks-chip-' + task.status + (task.status === 'success' && task.conversationId ? ' clickable' : '')}
               onClick={() => handleClick(task)}
               title={task.status === 'error' && task.errorMessage ? task.errorMessage : undefined}>
               <span className='active-tasks-chip-icon'>
                  {task.status === 'running' ? <span className='active-tasks-spinner' /> : ''}
                  {task.status === 'success' ? <IconDone fillColor='icon-green' style={{width:14,height:14,margin:0}} /> : ''}
                  {task.status === 'error' ? <IconWrong fillColor='icon-red' style={{width:14,height:14,margin:0}} /> : ''}
               </span>
               <span className='active-tasks-chip-label'>{labelFor(task)}</span>
               <span className='active-tasks-chip-dismiss' title={t.dismiss}
                  onClick={(e) => { e.stopPropagation(); dismissTask(task.id); }}>
                  <IconCloseX />
               </span>
            </div>
         ))}
      </div>
   );
}
